/*
 * Module for one lonesome report
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "underscore",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/shared/sortableList/sortableListModule",
  "modules/shared/sortableList/sortableListModel",
  "modules/topicsSplit/topic/topicResponseHistoryModal/topicResponseHistoryViewer/topicResponseHistoryViewerModule",
  "modules/learner/learnerTranscriptModal/learnerTranscriptModalModule",
  "modules/shared/surveyComments/surveyCommentsModule",
  "modules/topicsSplit/miniLearner/miniLearnerModule",
  "modules/topicsSplit/miniLearner/miniLearnerModel",
  "modules/tasks/tasksModel",
  "modules/topicsSplit/topic/topicModel",
  "modules/tasks/taskWizardModal/taskWizardModalModule",
  "modules/tasks/rejectTopicEditModal/rejectTopicEditModalModule",
  "modules/reportSplit/reports/reportModel",
  "modules/shared/redactSurveyCommentModal/redactSurveyCommentModalModule",
], function (
  Marionette,
  Backbone,
  Highcharts,
  $,
  _,
  Messenger,
  ReportUtilities,
  SortableListModule,
  SortableListModel,
  TopicResponseHistoryViewerModule,
  LearnerTranscriptModalModule,
  SurveyCommentsModule,
  MiniLearnerModule,
  MiniLearnerModel,
  TaskModel,
  TopicModel,
  TaskWizardModalModule,
  RejectTopicEditModalModule,
  ReportModel,
  RedactSurveyCommentModalModule,
) {
  "use strict";

  let list;

  const TableReportShow = function (report, module) {
    let value;
    let listEvents;
    let additionalI18N;
    let headers;

    let batchComplete = false;

    //If the user is an author, we shall include links to non-report areas of the programme
    //This will be true so long as the user is not a reports-only user
    const canAuthor = Messenger.reqres.request("user:is:author");
    const canCreateTask = Messenger.reqres.request("can:create:task");
    const isResponseReview = Messenger.reqres.request("active:kb:model").get("responseReview");

    if (report.type === "table") {
      const Header = SortableListModel.headerModel;
      let hideHeaders = false;
      let recordsPerPage = SortableListModule.DEFAULT_RECORDS_PER_PAGE;
      const href = "/" + report.href.split("/")[1];
      switch (href) {
        case "/escalation":
        case "/escalationConversation":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.escalationConversation.questions"),
              modelAttribute: "question",
              selectable: false,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.escalationConversation.count"),
              modelAttribute: "count",
              selectable: false,
              sortable: true,
              textField: false,
            }),
          ]);
          break;
        case "/fiscalPerformance":
          recordsPerPage = null; //hide pagination
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.fiscalPerformance.quarter"),
              modelAttribute: "quarter",
              selectable: false,
              sortable: false,
              textField: true,
            }),
            new Header({
              headerName: $.t("reports.fiscalPerformance.total"),
              modelAttribute: "total",
              selectable: false,
              sortable: false,
              textField: false,
              numericField: true,
            }),
            new Header({
              headerName: $.t("reports.fiscalPerformance.accuracy"),
              modelAttribute: "accuracy",
              selectable: false,
              sortable: false,
              textField: false,
              numericField: true,
            }),
          ]);
          break;
        case "/categoryTrafficDashboardDetail":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.categoryDetailReport.utterance"),
              modelAttribute: "utterance",
              selectable: false,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.categoryDetailReport.count"),
              modelAttribute: "count",
              selectable: false,
              sortable: true,
              textField: false,
            }),
          ]);
          break;
        case "/categoryTrafficDashboard":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.categoryReport.topic"),
              modelAttribute: "category",
              selectable: true,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.categoryReport.count"),
              modelAttribute: "count",
              selectable: false,
              sortable: true,
              textField: false,
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              //          //drilldown
              const topicID = model.get("topicID");
              const topicName = model.get("category");

              Messenger.vent.trigger("set:parameter", "topic", topicID);
              Messenger.vent.trigger("set:parameter", "selectedTopicName", topicName);
              /**
               * Another attribute of the dataSet for the pieChart reqres is the drillDownReport (which we get from the
               * reportModel).  Here, we retrieve that.
               */
              const ddReport = report.drillDownReport;
              /**
               * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report"
               * will
               * re-route back to the top of this showReport method, with the new report to show as the first
               * parameter.
               * We also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling
               * down to wipe out config settings).  The last parameter being true is really confusing right now and I
               * need to refactor that.  For now, setting it as true makes the drilldown show up.
               */
              if (ddReport) {
                for (let c = 0; c < ddReport.length; c++) {
                  const currentDrillDown = ddReport[c];
                  Messenger.vent.trigger("show:drilldown", currentDrillDown);
                }
              }
            },
            module,
          );
          break;
        case "/agentAssistTable":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.agentAssistTable.userName"),
              modelAttribute: "userName",
              selectable: false,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.agentAssistTable.cases"),
              modelAttribute: "numCases",
              selectable: false,
              sortable: true,
              textField: false,
            }),
          ]);
          break;
        case "/accuracyFMeasure":
        case "/accuracyTopic":
          hideHeaders = true;
          recordsPerPage = null;
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.accuracy.type"),
              modelAttribute: "type",
              selectable: false,
              sortable: false,
              textField: false,
            }),
            new Header({
              headerName: $.t("reports.accuracy.percent"),
              modelAttribute: "amount",
              selectable: false,
              sortable: false,
              textField: false,
            }),
          ]);

          additionalI18N = [
            {
              key: "overallAccuracy",
              value: $.t("reports.accuracy.overall"),
            },
            {
              key: "direct",
              value: $.t("reports.accuracy.direct"),
            },
            {
              key: "suggested",
              value: $.t("reports.accuracy.suggested"),
            },
            {
              key: "noMatch",
              value: $.t("reports.accuracy.nomatch"),
            },
            {
              key: "selected",
              value: $.t("reports.accuracy.selected"),
            },
            {
              key: "conversations",
              value: $.t("reports.accuracy.expected"),
            },
          ];
          break;
        case "/topicListing":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicListing.topicId"),
              modelAttribute: "topicID",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              hideable: true,
              hidden: true,
              textField: false,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.topicName"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              textField: false,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.topicNotes"),
              modelAttribute: "topicNotes",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              hidden: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.topicLabel"),
              modelAttribute: "topicLabel",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.topicLabelTouchpoint"),
              modelAttribute: "topicLabelTouchpoint",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              hidden: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.response"),
              modelAttribute: "response",
              filterable: false,
              sortable: false,
              textField: false,
              hideable: true,
              escapeHTML: false,
              width: "26%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.reasonCode"),
              modelAttribute: "reasonCode",
              filterable: false,
              sortable: false,
              textField: false,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.touchpoint"),
              modelAttribute: "touchpoint",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.language"),
              modelAttribute: "language",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.categories"),
              modelAttribute: "categories",
              filterable: true,
              sortable: false,
              textField: false,
              commaSeparatedField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.attributes"),
              modelAttribute: "attributes",
              filterable: true,
              sortable: false,
              textField: false,
              commaSeparatedField: true,
              hideable: true,
              hidden: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.status"),
              modelAttribute: "status",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.context"),
              modelAttribute: "context",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.associatedContent"),
              modelAttribute: "associatedContent",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              hidden: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicListing.lastUpdatedDate"),
              modelAttribute: "lastUpdatedDate",
              filterable: false,
              sortable: true,
              dateField: true,
              hideable: true,
              hidden: true,
              width: "8%",
            }),
          ]);
          if (isResponseReview) {
            headers.add([
              new Header({
                headerName: $.t("reports.topicListing.reviewedOnDate"),
                modelAttribute: "reviewedTimestamp",
                filterable: false,
                sortable: true,
                dateField: true,
                hideable: true,
                hidden: true,
                width: "8%",
              }),
              new Header({
                headerName: $.t("reports.topicListing.reviewedByUser"),
                modelAttribute: "reviewedUserName",
                filterable: false,
                sortable: true,
                textField: true,
                hideable: true,
                hidden: true,
                width: "8%",
              }),
            ]);
          }

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicID = model.get("topicID");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicID, { trigger: true });
            },
            module,
          );
          break;
        case "/reasonCode":
          if (Messenger.reqres.request("param:{reasonWithOrWithout}") === "with") {
            headers = new Backbone.Collection([
              new Header({
                headerName: $.t("reports.reasonCode.topic"),
                modelAttribute: "name",
                selectable: canAuthor,
                sortable: true,
                textField: false,
                longTextField: true,
                filterable: true,
              }),
              new Header({
                headerName: $.t("reports.reasonCode.codes"),
                modelAttribute: "code",
                selectable: false,
                sortable: true,
                textField: false,
              }),
            ]);
          } else {
            headers = new Backbone.Collection([
              new Header({
                headerName: $.t("reports.reasonCode.topic"),
                modelAttribute: "name",
                selectable: canAuthor,
                sortable: true,
                textField: false,
                longTextField: true,
                filterable: true,
              }),
            ]);
          }
          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicID = model.get("intentId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicID, { trigger: true });
            },
            module,
          );
          break;
        case "/contentAwarenessMissing":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.contentAwareness.contentName"),
              modelAttribute: "name",
              selectable: canAuthor,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.contentAwareness.url"),
              modelAttribute: "url",
              selectable: false,
              sortable: true,
              textField: false,
              width: "60%",
              customHtml: '<div class="wrap"><%- url %></div>',
            }),
            new Header({
              headerName: $.t("reports.contentAwareness.dateTime"),
              modelAttribute: "dateTime",
              selectable: false,
              sortable: true,
              textField: false,
              dateField: true,
              dateOnly: true,
            }),
            new Header({
              headerName: $.t("reports.contentAwareness.reason"),
              modelAttribute: "reason",
              filterable: true,
              selectable: false,
              sortable: true,
              textField: true,
            }),
          ]);

          Messenger.vent.on(
            "missingContent:selected:row",
            function (model) {
              const contentID = model.get("contentID");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/content/" + contentID, { trigger: true });
            },
            module,
          );
          break;
        case "/contentAwarenessNew":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.contentAwareness.contentName"),
              modelAttribute: "name",
              selectable: false,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.contentAwareness.url"),
              modelAttribute: "url",
              selectable: false,
              sortable: true,
              textField: false,
              width: "60%",
              customHtml: '<div class="wrap"><%- url %></div>',
            }),
            new Header({
              headerName: $.t("reports.contentAwareness.dateTime"),
              modelAttribute: "dateTime",
              selectable: false,
              sortable: true,
              textField: false,
              dateField: true,
            }),
          ]);
          break;
        case "/contentAwarenessModified":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.contentAwareness.contentName"),
              modelAttribute: "name",
              selectable: canAuthor,
              sortable: true,
              textField: false,
            }),
            new Header({
              headerName: $.t("reports.contentAwareness.dateTime"),
              modelAttribute: "dateTime",
              selectable: false,
              sortable: true,
              textField: false,
              dateField: true,
              dateOnly: true,
            }),
          ]);

          Messenger.vent.on(
            "modifiedContent:selected:row",
            function (model) {
              const contentID = model.get("contentID");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/content/" + contentID, { trigger: true });
            },
            module,
          );
          break;
        case "/accuracyDistribution":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.accuracyDistributionDrilldown.topic"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              sortable: true,
              textField: false,
            }),
            new Header({
              headerName: $.t("reports.accuracyDistributionDrilldown.count"),
              modelAttribute: "count",
              selectable: false,
              filterable: true,
              numericField: true,
              sortable: true,
              textField: false,
            }),
            new Header({
              headerName: $.t("reports.accuracyDistributionDrilldown.accuracy"),
              modelAttribute: "accuracy",
              selectable: false,
              sortable: true,
              textField: false,
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicID = model.get("topicID");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicID, { trigger: true });
            },
            module,
          );
          break;
        case "/surveyReport":
          //event handling for clicking on the 'view comments' button
          listEvents = {
            "click #comment": function () {
              const configBundle = {
                touchPoints: Messenger.reqres.request("param:{touchpoint}", "{touchpoint}"),
                topicId: this.model.get("topicID"), //'this' is the survey details record
                language: Messenger.reqres.request("param:{language}", "{language}"),
                startDate: Messenger.reqres.request("param:{startDate}", "{startDate}"),
                endDate: Messenger.reqres.request("param:{endDate}", "{endDate}"),
                surveyChoice: Messenger.reqres.request("param:{surveyChoice}", "{surveyChoice}"),
                deleteComments: canAuthor,
              };
              Messenger.vent.trigger("show:modal", SurveyCommentsModule, null, configBundle, {
                title: "reports.surveyDrilldown.comments",
                closeButton: true,
                closeOnBackgroundClick: true,
                trackInteraction: {
                  action: "Report Drilldown Survey Comments",
                  object: "Survey Comments",
                },
              });
            },
          };
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.surveyDrilldown.topic"),
              modelAttribute: "topic",
              selectable: canAuthor,
              sortable: true,
              filterable: true,
              textField: false,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyDrilldown.percentage"),
              modelAttribute: "percent",
              selectable: false,
              sortable: true,
              defaultReversed: true,
              filterable: true,
              numericField: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.surveyDrilldown.count"),
              modelAttribute: "count",
              selectable: false,
              sortable: true,
              defaultReversed: true,
              filterable: true,
              numericField: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.surveyDrilldown.comments"),
              modelAttribute: "commentCount",
              customHtml:
                "<% if (commentCount > 0) { %><button id='comment' class='btn btn-astute'><span data-i18n='reports.surveyDrilldown.viewComments'></span> (<%- commentCount %>)</button><% } %>",
              selectable: false,
              sortable: true,
              defaultReversed: true,
              filterable: true,
              numericField: true,
              hideable: true,
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicID = model.get("topicID");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicID, { trigger: true });
            },
            module,
          );

          value = $.t("reports.surveyDrilldown.downloadableTitle");
          value = ReportUtilities.figureOutText(value, true);
          additionalI18N = [
            {
              key: "downloadableTitle",
              value: value,
            },
            {
              key: "shortTitle",
              value: $.t("reports.surveyDrilldown.shortTitle"),
            },
          ];
          break;
        case "/topicHistory":
          if (canAuthor) {
            const kbId = Messenger.reqres.request("active:kb");
            headers = new Backbone.Collection([
              new Header({
                headerName: $.t("reports.topicHistory.topicId"),
                modelAttribute: "topicId",
                selectable: false,
                filterable: false,
                sortable: true,
                hideable: true,
                hidden: true,
                textField: false,
                customHtml: function (model) {
                  if (model.get("action") === "Deleted Intent") {
                    // no need for a link as it will result in invalid Intent Id error since the topic is deleted
                    return model.get("topicId");
                  } else {
                    return '<a href="#' + kbId + '/topic/<%- topicId %>"><%- topicId %></a>';
                  }
                },
              }),
              new Header({
                headerName: $.t("reports.topicHistory.topic"),
                modelAttribute: "topicName",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: false,
                longTextField: true,
                customHtml: function (model) {
                  if (model.get("action") === "Deleted Intent") {
                    // no need for a link as it will result in invalid Intent Id error since the topic is deleted
                    return model.get("topicName");
                  } else {
                    return '<a href="#' + kbId + '/topic/<%- topicId %>"><%- topicName %></a>';
                  }
                },
              }),
              new Header({
                headerName: $.t("reports.topicHistory.action"),
                modelAttribute: "action",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.dateTime"),
                modelAttribute: "dateTime",
                selectable: false,
                sortable: true,
                defaultSort: true,
                defaultReversed: true,
                dateField: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.user"),
                modelAttribute: "user",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
                hideable: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.touchPoint"),
                modelAttribute: "touchPoint",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
                hideable: true,
                hidden: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.locale"),
                modelAttribute: "locale",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
                hideable: true,
                hidden: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.showDetails"),
                modelAttribute: "",
                selectable: true,
                customHtml:
                  '<a id="previewButton" data-toggle="tooltip" data-i18n="[title]content.tooltip.showDetails" title="Show Details" data-original-title="Show Details">\n\
                  <i id="selectableField" class="icon-plus-sign icon-2x astute-blue"></i></a>',
              }),
            ]);
          } else {
            headers = new Backbone.Collection([
              new Header({
                headerName: $.t("reports.topicHistory.topicId"),
                modelAttribute: "topicId",
                selectable: false,
                filterable: false,
                sortable: true,
                hideable: true,
                hidden: true,
                textField: false,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.topic"),
                modelAttribute: "topicName",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: false,
                longTextField: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.action"),
                modelAttribute: "action",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.dateTime"),
                modelAttribute: "dateTime",
                selectable: false,
                sortable: true,
                defaultSort: true,
                defaultReversed: true,
                dateField: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.user"),
                modelAttribute: "user",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
                hideable: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.touchPoint"),
                modelAttribute: "touchPoint",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
                hideable: true,
                hidden: true,
              }),
              new Header({
                headerName: $.t("reports.topicHistory.locale"),
                modelAttribute: "locale",
                selectable: false,
                sortable: true,
                filterable: true,
                textField: true,
                hideable: true,
                hidden: true,
              }),
            ]);
          }

          Messenger.vent.on(
            "selected:row",
            function (model) {
              if (model.get("action") === "Disabled Topic") {
                // this is a topic disabled change type. In this case show no details
                return;
              }
              const transactionId = model.get("transactionId");
              const topicId = model.get("topicId");
              const topic = Messenger.reqres.request("topic", topicId);
              topic.once("error", function () {
                const headers = Messenger.reqres.request("topic:history:headers", "errorModal");
                headers.onSynced(function () {
                  Messenger.okDialog(
                    "History could not be shown because the topic no longer exists.",
                  );
                });
              });
              topic.onSynced(function () {
                const action = model.get("action");
                if (
                  action.toLowerCase() ===
                    TopicModel.actionTypes.PUBLISHED_RESPONSE.toLowerCase() ||
                  action.toLowerCase() === TopicModel.actionTypes.DISABLED_RESPONSE.toLowerCase() ||
                  action.toLowerCase() === TopicModel.actionTypes.ENABLED_RESPONSE.toLowerCase()
                ) {
                  const conversation = topic.conversation();
                  conversation.onSynced(function () {
                    let language = model.get("locale");
                    const langs = Messenger.reqres.request("kb:languages");
                    for (let i = 0; i < langs.models.length; i++) {
                      if (langs.models[i].get("name") === language) {
                        language = langs.models[i].get("id");
                        break;
                      }
                    }
                    let responseHistory = conversation.getResponseHistory(
                      model.get("touchpointId"),
                      language,
                    );
                    responseHistory.onSynced(function () {
                      const selectedResponse = new Backbone.Collection();
                      for (let i = 0; i < responseHistory.length; i++) {
                        if (responseHistory.models[i].get("transactionId") === transactionId) {
                          selectedResponse.add(responseHistory.models[i]);
                          break;
                        }
                      }
                      responseHistory = selectedResponse;
                      console.log(responseHistory);
                      Messenger.vent.trigger(
                        "show:modal",
                        TopicResponseHistoryViewerModule,
                        {
                          hideRollback: true,
                        },
                        responseHistory.models[0],
                        {
                          title: "reports.topicHistory.responseModalTitle",
                          closeButton: true,
                          closeOnBackgroundClick: true,
                          modalHeight: "auto",
                          trackInteraction: {
                            action: "Report Drilldown Response",
                            object: "Topic Response",
                          },
                        },
                      );
                    });
                  });
                } else {
                  let history = topic.history(transactionId);
                  history.onSynced(function () {
                    let headers;
                    if (model.get("action").toLowerCase().endsWith("response template")) {
                      headers = Messenger.reqres.request(
                        "topic:history:headers",
                        "detailModalHtml",
                      );
                    } else {
                      headers = Messenger.reqres.request("topic:history:headers", "detailModal");
                    }
                    headers.onSynced(function () {
                      Messenger.vent.trigger(
                        "show:modal",
                        SortableListModule,
                        {
                          headers: headers,
                          hideControls: true,
                          namespace: "history",
                        },
                        history,
                        {
                          title: history.models[0].get("changeType"),
                          closeButton: true,
                          closeOnBackgroundClick: true,
                          modalHeight: "600px",
                          trackInteraction: {
                            action: "Report Drilldown History",
                            object: "Topic History",
                          },
                        },
                      );
                    });
                  });
                }
              });
            },
            module,
          );
          break;
        case "/contentHistory":
          headers = new Backbone.Collection([
            //Coming back to fix the href link in this header...we shouldn't navigate to parts of the website using url links.
            // It's a single page application!
            new Header({
              headerName: $.t("reports.contentHistory.mappingName"),
              modelAttribute: "mappingName",
              selectable: canAuthor,
              sortable: true,
              filterable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.contentHistory.oldValue"),
              modelAttribute: "oldValue",
              selectable: false,
              sortable: true,
              filterable: true,
              longTextField: true,
              width: "30%",
              customHtml: '<div class="wrap"><%- oldValue %></div>',
            }),
            new Header({
              headerName: $.t("reports.contentHistory.newValue"),
              modelAttribute: "newValue",
              selectable: false,
              sortable: true,
              filterable: true,
              longTextField: true,
              width: "30%",
              customHtml: '<div class="wrap"><%- newValue %></div>',
            }),
            new Header({
              headerName: $.t("reports.contentHistory.user"),
              modelAttribute: "user",
              selectable: false,
              sortable: true,
              filterable: true,
              textField: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.contentHistory.dateTime"),
              modelAttribute: "dateTime",
              selectable: false,
              sortable: true,
              defaultSort: true,
              defaultReversed: true,
              dateField: true,
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicID = model.get("mappingId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/content/" + topicID, { trigger: true });
            },
            module,
          );
          break;
        case "/voiceOfTheCustomer":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.question"),
              modelAttribute: "userUtterance",
              selectable: true,
              sortable: true,
              filterable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.count"),
              modelAttribute: "count",
              sortable: true,
              defaultSort: true,
              defaultReversed: true,
              filterable: true,
              numericField: true,
            }),
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.topicMatches"),
              modelAttribute: "topicMatchNames",
              arrayField: true,
              sortable: true,
              filterable: true,
            }),
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.touchPointName"),
              modelAttribute: "touchPointName",
              sortable: true,
              filterable: true,
              textField: true,
              hideable: true,
              hidden: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.touchPointId"),
              modelAttribute: "touchPointId",
              sortable: true,
              filterable: true,
              numericField: true,
              hideable: true,
              hidden: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.localeName"),
              modelAttribute: "localeName",
              sortable: true,
              filterable: true,
              textField: true,
              hideable: true,
              hidden: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.voiceOfTheCustomer.localeId"),
              modelAttribute: "localeId",
              sortable: true,
              filterable: true,
              numericField: true,
              hideable: true,
              hidden: true,
              width: "10%",
            }),
          ]);

          additionalI18N = [
            {
              key: "noTopicMatch",
              value: $.t("common.none"),
            },
          ];

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const modalTitle = $.t("reports.voiceOfTheCustomer.clusteredTitle");

              Messenger.vent.trigger(
                "show:modal",
                LearnerTranscriptModalModule,
                {
                  matchType: module.matchType,
                  disableLearnerFeatures: true,
                },
                model,
                {
                  title: modalTitle,
                  closeButton: true,
                  closeOnBackgroundClick: true,
                  trackInteraction: {
                    action: "Show Learner Transcript",
                    object: "Learner Transcript",
                    source: "Voice of the Customer Report",
                  },
                },
              );
            },
            module,
          );
          break;
        case "/examplesPerTopic":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.examplesPerTopic.topicName"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              sortable: true,
              textField: false,
            }),
            new Header({
              headerName: $.t("reports.examplesPerTopic.exampleCount"),
              modelAttribute: "exampleCount",
              selectable: false,
              sortable: true,
              textField: false,
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("topicId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/tasksReport":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.tasksReport.taskType"),
              modelAttribute: "taskType",
              selectable: false,
              filterable: true,
              sortable: true,
              textField: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.tasksReport.topic"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              filterable: true,
              sortable: true,
              longTextField: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.tasksReport.categories"),
              modelAttribute: "categories",
              filterable: true,
              sortable: false,
              textField: false,
              commaSeparatedField: true,
              hideable: true,
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.tasksReport.taskDescription"),
              modelAttribute: "description",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              width: "20%",
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.tasksReport.taskComments"),
              modelAttribute: "comments",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              width: "24%",
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.tasksReport.assignee"),
              modelAttribute: "assignee",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.tasksReport.dueDate"),
              modelAttribute: "dueDate",
              filterable: false,
              sortable: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.tasksReport.status"),
              modelAttribute: "status",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.tasksReport.recurrence"),
              modelAttribute: "taskInterval",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
              customHtml: function (model) {
                return $.t("task.interval." + model.get("taskInterval").toLowerCase());
              },
            }),
            new Header({
              headerName: $.t("reports.tasksReport.creator"),
              modelAttribute: "creator",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.tasksReport.language"),
              modelAttribute: "locales",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              width: "10%",
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.tasksReport.touchpoint"),
              modelAttribute: "touchpoint",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "10%",
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.tasksReport.createDate"),
              modelAttribute: "createDate",
              filterable: false,
              sortable: true,
              hideable: true,
              width: "8%",
              hidden: false,
            }),
            new Header({
              headerName: $.t("reports.tasksReport.finishDate"),
              modelAttribute: "finishDate",
              filterable: false,
              sortable: true,
              hideable: true,
              width: "8%",
              hidden: true,
            }),
          ]);

          additionalI18N = [
            {
              key: "topicReview",
              value: $.t("task.type.topicReview"),
            },
            {
              key: "updateResponse",
              value: $.t("task.type.updateResponse"),
            },
            {
              key: "notStarted",
              value: $.t("task.status.notStarted"),
            },
            {
              key: "completed",
              value: $.t("task.status.completed"),
            },
            {
              key: "approved",
              value: $.t("task.status.approved"),
            },
            {
              key: "rejected",
              value: $.t("task.status.rejected"),
            },
            {
              key: "inProgress",
              value: $.t("task.status.inProgress"),
            },
            {
              key: "ignored",
              value: $.t("task.status.ignored"),
            },
            {
              key: "resubmitted",
              value: $.t("task.status.resubmitted"),
            },
          ];

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("topicId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/topicsWithMissingContent":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("Topic"),
              modelAttribute: "name",
              selectable: canAuthor,
              filterable: true,
              sortable: true,
              textField: true,
              width: "100%",
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("id");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/commentsReport":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.surveyCommentsReport.date"),
              modelAttribute: "date",
              sortable: true,
              dateField: true,
              defaultReversed: true,
              defaultSource: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.question"),
              modelAttribute: "questionAsked",
              filterable: true,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.topic"),
              modelAttribute: "intentName",
              selectable: canAuthor,
              sortable: true,
              filterable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.topicNotes"),
              modelAttribute: "intentDescription",
              filterable: true,
              hidden: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.rating"),
              modelAttribute: "rating",
              sortable: true,
              filterable: true,
              numericField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.comment"),
              modelAttribute: "comment",
              sortable: true,
              filterable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.categories"),
              modelAttribute: "categories",
              filterable: true,
              sortable: false,
              textField: false,
              commaSeparatedField: true,
              hideable: true,
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.topicEditSubmitterName"),
              modelAttribute: "topicEditSubmitterName",
              sortable: true,
              filterable: true,
              longTextField: true,
            }),
            new Header({
              headerName: $.t("reports.surveyCommentsReport.topicEditSubmitterEmail"),
              modelAttribute: "topicEditSubmitterEmail",
              sortable: true,
              filterable: true,
              longTextField: true,
            }),
          ]);

          if (canCreateTask) {
            headers.add([
              new Header({
                headerName: $.t("reports.surveyCommentsReport.topicEditRequest"),
                modelAttribute: "topicEditRequestStatus",
                width: "30px",
                customHtml:
                  '<% if (topicEditRequestStatus == "' +
                  TaskModel.TOPIC_EDIT_STATUS.SUBMITTED +
                  '") { %> \n' +
                  '<button type="button" class="topic-edit-request-button btn btn-astute"> \n' +
                  $.t("reports.surveyCommentsReport.createTask") +
                  "\n" +
                  "</button>" +
                  '<button type="button" class="topic-edit-reject-button btn btn-astute"> \n' +
                  $.t("reports.surveyCommentsReport.rejectEdit") +
                  "\n" +
                  "</button>" +
                  "<% } %>",
              }),
            ]);
            if (!listEvents) {
              listEvents = {};
            }
            listEvents["click .topic-edit-request-button"] = function () {
              const model = this.model;
              const task = Messenger.reqres.request("task:createAdvanced");
              task.set("description", model.get("comment"));
              task.set("intentId", model.get("intentId"));
              task.set("intentName", model.get("intentName"));
              task.set("topicEditRequestId", model.get("topicEditRequestId"));
              Messenger.vent.trigger("show:modal", TaskWizardModalModule, {}, task, {
                closeButton: false,
                closeOnBackgroundClick: false,
                title: "task.wizard.title",
                trackInteraction: {
                  action: "Add Advanced Task",
                  source: "Report",
                  id: [model.get("intentId"), model.get("topicEditRequestId")],
                  idType: ["Topic", "Topic Edit Request"],
                  object: "Topic Edit Request",
                },
              });
            };
            listEvents["click .topic-edit-reject-button"] = function () {
              const model = this.model;
              const topicEditRequest = Messenger.reqres.request("fetch:topicEditRequest", {
                id: model.get("topicEditRequestId"),
              });
              Messenger.vent.trigger(
                "show:modal",
                RejectTopicEditModalModule,
                {},
                topicEditRequest,
                {
                  closeButton: false,
                  closeOnBackgroundClick: false,
                  title: "task.rejectTopicEdit.title",
                  trackInteraction: {
                    action: "Reject Topic Edit Request",
                    id: [model.get("intentId"), model.get("topicEditRequestId")],
                    idType: ["Topic", "Topic Edit Request"],
                    object: "Topic Edit Request",
                  },
                },
              );
            };
          }

          if (canAuthor) {
            const redactTitle = $.t("reports.surveyDrilldown.redactComment");
            const deleteTitle = $.t("reports.surveyDrilldown.deleteComment");
            const toolHtml = `
<% if (!deleted) { %>
<button id="redactComment" type="button" class="btn btn-mini" title="${redactTitle}">
  <i class="icon-eraser"></i>
</button>
<button id="deleteComment" type="button" class="btn btn-danger btn-mini" title="${deleteTitle}">
  <i class="icon-remove"></i>
</button>
<% } %>
`;
            headers.add(
              new Header({
                headerName: "",
                modelAttribute: "deleted",
                width: "70px",
                customHtml: toolHtml,
              }),
            );
            if (!listEvents) {
              listEvents = {};
            }
            listEvents["click #deleteComment"] = function () {
              const model = this.model;
              Messenger.yesNoDialog("reports.surveyDrilldown.confirmDeleteComment", {
                yes: () => {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Survey Comment",
                    id: model.id,
                    idType: "Survey Comment",
                    object: "Survey Comment",
                    source: "Report",
                  });
                  const comments = Messenger.reqres.request("create:survey:comment");
                  comments.deleteComment(
                    model.get("date"),
                    model.get("touchpoint"),
                    model.get("localeId") || Messenger.reqres.request("param:{language}"),
                    model.get("rating"),
                    model.get("intentId"),
                    (m) => {
                      model.set("comment", m.get("comment"));
                      model.set("deleted", true);
                    },
                  );
                },
              });
            };
            listEvents["click #redactComment"] = function () {
              const model = this.model;
              Messenger.vent.trigger("show:modal", RedactSurveyCommentModalModule, {}, model, {
                title: $.t("surveyComments.redactComment.title"),
                trackInteraction: {
                  action: "Redact Survey User",
                  id: model.id,
                  idType: "Survey Comment",
                  object: "Survey Comment",
                  source: "Report",
                },
              });
            };
          }

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("intentId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/topicUsage":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicUsage.topicId"),
              modelAttribute: "topicId",
              sortable: true,
              selectable: false,
              filterable: false,
              hideable: true,
              hidden: true,
              textField: false,
            }),
            new Header({
              headerName: $.t("reports.topicUsage.topicName"),
              modelAttribute: "topicName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicUsage.categories"),
              modelAttribute: "categories",
              filterable: true,
              sortable: false,
              textField: false,
              commaSeparatedField: true,
              hideable: true,
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.topicUsage.count"),
              modelAttribute: "count",
              sortable: true,
              defaultSort: true,
              defaultReversed: true,
            }),
          ]);
          break;
        case "/snippetReport?touchPointIds={touchpoint}&localeIds={languages}&topic={topic}&snippetId={snippetId}":
          const kbId = Messenger.reqres.request("active:kb");
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.snippetReport.snippetName"),
              modelAttribute: "snippetName",
              sortable: true,
              customHtml: () => {
                return '<a href="#' + kbId + '/snippet/<%- snippetId %>"><%- snippetName %></a>';
              },
            }),
            new Header({
              headerName: $.t("reports.snippetReport.snippetDescription"),
              modelAttribute: "snippetDescription",
              hideable: true,
              hidden: true,
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.snippetReport.topicId"),
              modelAttribute: "intentId",
              hideable: true,
              hidden: true,
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.snippetReport.topicName"),
              modelAttribute: "intentName",
              sortable: true,
              customHtml: (model) => {
                if (!model.get("isExpectedAnswer")) {
                  return '<a href="#' + kbId + '/topic/<%- intentId %>"><%- intentName %></a>';
                }
                return "<%- intentName %>";
              },
            }),
            new Header({
              headerName: $.t("reports.snippetReport.touchpointName"),
              modelAttribute: "touchpointName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.snippetReport.languageName"),
              modelAttribute: "languageName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.snippetReport.lastModifiedBy"),
              modelAttribute: "lastModifiedBy",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.snippetReport.lastModifiedTime"),
              modelAttribute: "lastModifiedTime",
              dateField: true,
              sortable: true,
            }),
          ]);
          break;
        case "/topicStatus":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicStatus.topicId"),
              modelAttribute: "topicId",
              hideable: true,
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.topicStatus.topicName"),
              modelAttribute: "topicName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicStatus.status"),
              modelAttribute: "status",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicStatus.publishUser"),
              modelAttribute: "publishUser",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicStatus.publishDateTime"),
              modelAttribute: "publishDateTime",
              dateField: true,
              sortable: true,
            }),
          ]);
          break;
        case "/topicResponseStatus":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicResponseStatus.topicId"),
              modelAttribute: "topicId",
              hideable: true,
              hidden: true,
            }),
            new Header({
              headerName: $.t("reports.topicResponseStatus.topicName"),
              modelAttribute: "topicName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicResponseStatus.touchpoint"),
              modelAttribute: "touchpoint",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicResponseStatus.locale"),
              modelAttribute: "locale",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicStatus.status"),
              modelAttribute: "topicStatus",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicResponseStatus.status"),
              modelAttribute: "responseStatus",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicResponseStatus.publishUser"),
              modelAttribute: "responsePublishUser",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicResponseStatus.publishDateTime"),
              modelAttribute: "responsePublishDateTime",
              dateField: true,
              sortable: true,
            }),
          ]);
          break;
        case "/advancedTask":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.advancedTask.taskName"),
              modelAttribute: "taskName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.taskId"),
              modelAttribute: "taskId",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.userName"),
              modelAttribute: "userName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.timestamp"),
              modelAttribute: "timestamp",
              dateField: true,
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.changeType"),
              modelAttribute: "changeType",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.status"),
              modelAttribute: "status",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.departmentName"),
              modelAttribute: "departmentName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.intentName"),
              modelAttribute: "intentName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.recurrence"),
              modelAttribute: "taskInterval",
              sortable: true,
              customHtml: function (model) {
                return $.t("task.interval." + model.get("taskInterval").toLowerCase());
              },
            }),
            new Header({
              headerName: $.t("reports.advancedTask.comments"),
              modelAttribute: "comments",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.advancedTask.languageName"),
              modelAttribute: "languageName",
              sortable: true,
            }),
          ]);
          break;
        case "/taskOwnerProductivity":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.taskProductivity.taskOwnerName"),
              modelAttribute: "userName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.taskProductivity.tasksAssigned"),
              modelAttribute: "tasksAssigned",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.taskProductivity.tasksNotStarted"),
              modelAttribute: "tasksNotStarted",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.taskProductivity.tasksInProgress"),
              modelAttribute: "tasksInProgress",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.taskProductivity.tasksCompleted"),
              modelAttribute: "tasksCompleted",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.taskProductivity.averageTaskTime"),
              modelAttribute: "averageTaskTime",
              sortable: true,
              durationField: true,
            }),
            new Header({
              headerName: $.t("reports.taskProductivity.averageHandleTime"),
              modelAttribute: "averageHandleTime",
              sortable: true,
              durationField: true,
            }),
          ]);
          break;
        case "/topicFeedback":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicFeedback.email"),
              modelAttribute: "email",
              sortable: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedback.requestDate"),
              modelAttribute: "requestDate",
              sortable: true,
              hideable: true,
              dateField: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedback.taskCreateDate"),
              modelAttribute: "taskCreateDate",
              sortable: true,
              hideable: true,
              dateField: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedback.taskStartDate"),
              modelAttribute: "taskStartDate",
              sortable: true,
              hideable: true,
              dateField: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedback.taskCompleteDate"),
              modelAttribute: "taskCompleteDate",
              sortable: true,
              hideable: true,
              dateField: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedback.taskCompleteDuration"),
              modelAttribute: "taskCompleteDuration",
              sortable: true,
              hideable: true,
              durationField: true,
            }),
          ]);
          break;
        case "/topicFeedbackByTouchpoint":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.touchpointName"),
              modelAttribute: "touchpointName",
              sortable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.submitted"),
              modelAttribute: "submitted",
              sortable: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.tasksCreated"),
              modelAttribute: "tasksCreated",
              sortable: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.tasksCompleted"),
              modelAttribute: "tasksCompleted",
              sortable: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.tasksInProgress"),
              modelAttribute: "tasksInProgress",
              sortable: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.tasksNotStarted"),
              modelAttribute: "tasksNotStarted",
              sortable: true,
              hideable: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.averageResponseTime"),
              modelAttribute: "averageResponseTime",
              sortable: true,
              hideable: true,
              durationField: true,
            }),
            new Header({
              headerName: $.t("reports.topicFeedbackByTouchpoint.averageTimeToCompletion"),
              modelAttribute: "averageTimeToCompletion",
              sortable: true,
              hideable: true,
              durationField: true,
            }),
          ]);
          break;
        case "/topicExampleListing":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicExampleListing.topicId"),
              modelAttribute: "topicId",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              hideable: true,
              hidden: true,
              numericField: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicExampleListing.topicName"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              textField: false,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicExampleListing.exampleId"),
              modelAttribute: "exampleId",
              filterable: true,
              sortable: true,
              numericField: true,
              hideable: true,
              hidden: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicExampleListing.exampleText"),
              modelAttribute: "exampleText",
              filterable: true,
              sortable: true,
              longTextField: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicExampleListing.languageName"),
              modelAttribute: "languageName",
              filterable: true,
              sortable: true,
              textField: true,
              hideable: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicExampleListing.changeTimestamp"),
              modelAttribute: "changeTimestamp",
              filterable: true,
              sortable: true,
              dateField: true,
              hideable: true,
              hidden: true,
              width: "8%",
            }),
            new Header({
              headerName: $.t("reports.topicExampleListing.suppressFromAutocomplete"),
              modelAttribute: "suppressFromAutocomplete",
              filterable: true,
              sortable: true,
              longTextField: true,
              hideable: true,
              hidden: true,
              width: "20%",
              customHtml: function (model) {
                const value = model.get("suppressFromAutocomplete");
                const lowerValue = value ? value.toLowerCase() : "";
                if ("all" == lowerValue) {
                  return $.t("reports.topicExampleListing.allSuppressed");
                } else if ("none" == lowerValue) {
                  return $.t("reports.topicExampleListing.noneSuppressed");
                }
                return value;
              },
            }),
          ]);

          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("topicId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/standardResponseTrackClickListing":
        case "/topicTrackClickListing":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicTrackClickListing.targetId"),
              modelAttribute: "targetId",
              hideable: true,
              hidden: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicTrackClickListing.targetType"),
              modelAttribute: "targetType",
              filterable: true,
              sortable: true,
              hideable: true,
              textField: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicTrackClickListing.targetName"),
              modelAttribute: "targetName",
              filterable: true,
              sortable: true,
              hideable: true,
              longTextField: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicTrackClickListing.targetUrl"),
              modelAttribute: "targetUrl",
              filterable: true,
              sortable: true,
              hideable: true,
              longTextField: true,
              width: "50%",
            }),
            new Header({
              headerName: $.t("reports.topicTrackClickListing.count"),
              modelAttribute: "count",
              sortable: true,
              hideable: true,
              width: "10%",
            }),
          ]);
          break;
        case "/topicScheduledStatusChange":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicScheduledStatusChange.topicId"),
              modelAttribute: "topicId",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              hideable: true,
              hidden: true,
              numericField: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicScheduledStatusChange.topicName"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              hideable: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicScheduledStatusChange.currentStatus"),
              modelAttribute: "currentStatus",
              filterable: true,
              textField: true,
              sortable: true,
              hideable: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicScheduledStatusChange.scheduledStatus"),
              modelAttribute: "scheduledStatus",
              filterable: true,
              textField: true,
              sortable: true,
              hideable: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicScheduledStatusChange.scheduledDate"),
              modelAttribute: "scheduledDate",
              sortable: true,
              hideable: true,
              textField: false,
              dateField: true,
              width: "30%",
            }),
          ]);
          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("topicId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/topicResponseScheduledStatusChange":
          headers = new Backbone.Collection([
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.topicId"),
              modelAttribute: "topicId",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              hideable: true,
              hidden: true,
              numericField: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.topicName"),
              modelAttribute: "topicName",
              selectable: canAuthor,
              filterable: false,
              sortable: true,
              hideable: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.currentStatus"),
              modelAttribute: "currentStatus",
              filterable: true,
              textField: true,
              sortable: true,
              hideable: true,
              width: "20%",
            }),
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.scheduledStatus"),
              modelAttribute: "scheduledStatus",
              filterable: true,
              textField: true,
              sortable: true,
              hideable: true,
              width: "15%",
            }),
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.touchpointName"),
              modelAttribute: "touchpointName",
              filterable: true,
              textField: true,
              sortable: true,
              hideable: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.language"),
              modelAttribute: "language",
              filterable: true,
              textField: true,
              sortable: true,
              hideable: true,
              width: "10%",
            }),
            new Header({
              headerName: $.t("reports.topicResponseScheduledStatusChange.scheduledDate"),
              modelAttribute: "scheduledDate",
              sortable: true,
              hideable: true,
              textField: false,
              dateField: true,
              width: "15%",
            }),
          ]);
          Messenger.vent.on(
            "selected:row",
            function (model) {
              const topicId = model.get("topicId");
              const kbId = Messenger.reqres.request("active:kb");
              Backbone.history.navigate(kbId + "/topic/" + topicId, { trigger: true });
            },
            module,
          );
          break;
        case "/userAudit":
          headers = new SortableListModel.headerCollection([
            {
              headerName: $.t("reports.userAudit.userId"),
              modelAttribute: "userId",
              filterable: true,
              hideable: true,
              numericField: true,
            },
            {
              headerName: $.t("reports.userAudit.fullName"),
              modelAttribute: "name",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.loginId"),
              modelAttribute: "loginId",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.phone"),
              modelAttribute: "phone",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.email"),
              modelAttribute: "email",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.organization"),
              modelAttribute: "organization",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.createDate"),
              modelAttribute: "createDate",
              filterable: true,
              hideable: true,
              sortable: true,
              dateField: true,
            },
            {
              headerName: $.t("reports.userAudit.state"),
              modelAttribute: "state",
              filterable: true,
              hideable: true,
              sortable: true,
              textField: true,
            },
            {
              headerName: $.t("reports.userAudit.roles"),
              modelAttribute: "roles",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.contexts"),
              modelAttribute: "contexts",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.departments"),
              modelAttribute: "departments",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
            {
              headerName: $.t("reports.userAudit.touchPoints"),
              modelAttribute: "touchPoints",
              filterable: true,
              hideable: true,
              sortable: true,
              longTextField: true,
            },
          ]);
          break;
      }

      let dataSet;
      const dataSetBatch = new Backbone.Collection(); // Used for combining the topic listing batches

      if (
        report.href ===
        "/voiceOfTheCustomer/{startDate}/{endDate}/{matchType}/{statusId}/{language}?touchPointIds={touchpoint}&analyticsTags={analyticsTags}"
      ) {
        dataSet = Messenger.reqres.request("voc:clustered:search:results", report.href);
      } else if (report.href === ReportModel.hrefs.TOPIC_LISTING_BATCH) {
        dataSet = Messenger.reqres.request("topic:listing:batch:data", report.href);
      } else {
        dataSet = Messenger.reqres.request("tableData", report.href);
      }

      Messenger.vent.on("topic:listing:batch:complete", function () {
        batchComplete = true;
      });

      module.listenTo(dataSet, "sync", function () {
        if (report.href === ReportModel.hrefs.TOPIC_LISTING_BATCH) {
          dataSetBatch.add(dataSet.models);
          if (batchComplete === true) {
            dataSetBatch.trigger("sync"); // Trigger this manually so the pagination will display in the table
            dataSetBatch.url = dataSet.url();
            dataSetBatch.downloadUrl = dataSet.downloadUrl();
            _setUpTable(
              report,
              module,
              dataSetBatch,
              headers,
              hideHeaders,
              recordsPerPage,
              listEvents,
              additionalI18N,
            );
          }
        } else {
          _setUpTable(
            report,
            module,
            dataSet,
            headers,
            hideHeaders,
            recordsPerPage,
            listEvents,
            additionalI18N,
          );
        }
      });
    }
  };

  const _setUpTable = function (
    report,
    module,
    dataSet,
    headers,
    hideHeaders,
    recordsPerPage,
    listEvents,
    additionalI18N,
  ) {
    let m;
    let max;
    let namespace;
    let currentTitle;
    module.showRegion(module.layout);
    Messenger.vent.trigger("report:arrived", report);
    console.log(dataSet);

    if (report.options.title) {
      currentTitle = $.t(report.options.title);
      currentTitle = ReportUtilities.figureOutText(currentTitle, true);
    } else {
      currentTitle = null;
    }

    //andjon 6/18/2014 - Handle namespaces so that if there are multiple reports on the same page, sorting/filtering
    // still works properly
    if (report.options.namespace) {
      namespace = report.options.namespace;
    } else {
      namespace = null;
    }

    Messenger.reqres.setHandler(
      "report:i18nHeaders:" + report.options.downloadUrlShort.substring(1),
      function () {
        let i;
        const retVal = {};
        const headersJSON = headers.toJSON();
        for (i = 0; i < headersJSON.length; i++) {
          if (!headersJSON[i].hidden) {
            retVal[headersJSON[i].modelAttribute] = headersJSON[i].headerName;
          }
        }

        //additional stuff
        if (additionalI18N !== undefined) {
          for (i = 0; i < additionalI18N.length; i++) {
            retVal[additionalI18N[i].key] = additionalI18N[i].value;
          }
        }
        //title
        if (currentTitle !== null) {
          retVal["title"] = currentTitle;
        }

        return retVal;
      },
    );

    //translate labels that need I18N'ed
    if (
      report.href ===
      "/voiceOfTheCustomer/{startDate}/{endDate}/{matchType}/{touchpoint}?analyticsTags={analyticsTags}"
    ) {
      for (let k = 0; k < dataSet.models.length; k++) {
        const response = dataSet.models[k];
        response.set("utterance", response.get("utterance").trim());
      }
    }
    if (report.href.startsWith("/accuracyFMeasure/") || report.href.startsWith("/accuracyTopic/")) {
      max = dataSet.models.length;
      for (m = 0; m < max; m++) {
        dataSet.models[m].set("type", $.t(dataSet.models[m].get("type")));
        if (m === 0) {
          continue;
        }
        dataSet.models[m].set("amount", dataSet.models[m].get("amount").toFixed(1) + "%");
      }
    }
    if (report.href.startsWith("/tasksReport/")) {
      max = dataSet.models.length;
      for (m = 0; m < max; m++) {
        const model = dataSet.models[m];
        const originalType = model.get("taskType");
        model.set("taskType", $.t(model.get("taskType")));
        model.set("dueDate", Messenger.reqres.request("get:formatted:date", model.get("dueDate")));
        model.set(
          "createDate",
          Messenger.reqres.request("get:formatted:dateTime", model.get("createDate")),
        );
        model.set(
          "finishDate",
          Messenger.reqres.request("get:formatted:dateTime", model.get("finishDate")),
        );
        //status
        const intStatus = Number(model.get("status"));
        if (intStatus === TaskModel.STATUS.NOT_STARTED) {
          model.set("status", $.t("task.status.notStarted"));
        } else if (intStatus === TaskModel.STATUS.COMPLETED) {
          if (originalType === "task.type.topicReview") {
            model.set("status", $.t("task.status.approved"));
          } else {
            model.set("status", $.t("task.status.completed"));
          }
        } else if (intStatus === TaskModel.STATUS.FAILED) {
          model.set("status", $.t("task.status.rejected"));
        } else if (intStatus === TaskModel.STATUS.IN_PROGRESS) {
          model.set("status", $.t("task.status.inProgress"));
        } else if (intStatus === TaskModel.STATUS.IGNORED) {
          model.set("status", $.t("task.status.ignored"));
        } else if (intStatus === TaskModel.STATUS.RESUBMITTED) {
          model.set("status", $.t("task.status.resubmitted"));
        }

        //locales
        if (!model.get("locales")) {
          model.set("locales", $.t("common.locale.none"));
        } else {
          const locales = model.get("locales").split(";");
          const localesDisplay = _.map(locales, function (locale) {
            if (!locale) {
              return $.t("common.locale.none");
            }
            return $.t("common.locale." + locale);
          });
          model.set("locales", localesDisplay.join("; "));
        }
        //touchpoint
        if (model.get("touchpoint") === null) {
          model.set("touchpoint", $.t("task.touchpoint.none"));
        }

        //unassigned
        if (model.get("assignee") === null) {
          model.set("assignee", $.t("topic.review.noUserAssigned"));
        }
      }
    }
    if (dataSet.models.length > 0) {
      //This should work with all reports, as all reports should have a unique downloadUrlShort, and thus a
      // different ID than all others visible at the same time
      report.downloadID = report.options.downloadUrlShort.substring(1);
      Messenger.reqres.setHandler("downloadUrl:" + report.downloadID, function () {
        return ReportUtilities.fetchReportParameters(report.options.downloadUrl);
      });

      if (report.downloadID !== undefined) {
        list = module.addSubModule(
          new SortableListModule({
            region: module.layout.chart,
            headers: headers,
            recordsPerPage: recordsPerPage,
            title: currentTitle,
            hideHeader: hideHeaders,
            namespace: namespace,
            downloadable: true,
            downloadID: report.downloadID,
            extendedEvents: listEvents,
          }),
        );
      } else {
        list = module.addSubModule(
          new SortableListModule({
            region: module.layout.chart,
            headers: headers,
            recordsPerPage: recordsPerPage,
            title: currentTitle,
            hideHeader: hideHeaders,
            namespace: namespace,
            downloadable: false,
          }),
        );
      }
      list.show(dataSet);
      list.trigger("fetched"); //manually trigger model's events
    } else {
      currentTitle = $.t("reports.noData.long");
      list = module.addSubModule(
        new SortableListModule({
          region: module.layout.chart,
          headers: null,
          recordsPerPage: recordsPerPage,
          title: currentTitle,
          hideHeader: true,
        }),
      );
      list.show(dataSet);
      list.trigger("fetched"); //manually trigger model's events
    }
  };

  return TableReportShow;
});
